export default function JoinFilter(module) {
    angular.module(module || 'app')
        .filter('join', join);

    function join() {
        return function (value, property, separator) {
            if (!value || !Array.isArray(value)) {
                return value;
            }
            if (!separator) {
                separator = ', ';
            }
            var result = property ? value[0][property] : value[0];
            for (var i = 1; i < value.length; i++) {
                result += separator + (property ? value[i][property] : value[i]);
            }
            return result;
        }
    }
}